import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z M22.0287 21.976V25H10.1727V21.712L15.3327 17.296C16.2767 16.496 16.9327 15.816 17.3007 15.256C17.6687 14.68 17.8527 14.04 17.8527 13.336V13C17.8527 12.36 17.6207 11.88 17.1567 11.56C16.6927 11.24 16.1887 11.08 15.6447 11.08C14.8607 11.08 14.2607 11.312 13.8447 11.776C13.4287 12.24 13.1327 12.792 12.9567 13.432L9.81269 12.232C10.0687 11.448 10.4527 10.736 10.9647 10.096C11.4927 9.456 12.1727 8.944 13.0047 8.56C13.8367 8.16 14.8287 7.96 15.9807 7.96C17.1967 7.96 18.2287 8.184 19.0767 8.632C19.9247 9.064 20.5727 9.656 21.0207 10.408C21.4687 11.16 21.6927 12.024 21.6927 13C21.6927 13.96 21.4847 14.816 21.0687 15.568C20.6687 16.304 20.1247 16.992 19.4367 17.632C18.7647 18.256 18.0287 18.888 17.2287 19.528L14.1087 21.976H22.0287Z",
		fill: "currentColor"
	})
});
export default Svg2;
